// extracted by mini-css-extract-plugin
export var quillEditor = "_pb-1";
export var variable = "_pb-0";